<template>
  <v-container>TBD</v-container>
</template>

<script>
export default {
  name: "Donate"
};
</script>
